module.exports = __webpack_public_path__ + "static/media/rodean.d30ee428.jpg";